//导入axios
import axios from 'axios';
import {userTokenStore} from "@/store/store.js";
import {userLogoutHooks} from "@/hooks/user.js";

// 创建 Axios 实例
const instance = axios.create({
    baseURL: import.meta.env.VITE_API_URL, // 从环境变量中读取 baseURL
    timeout: import.meta.env.VITE_API_TTL, // 请求超时时间
});

// 拦截器白名单
const whiteList = ["/menu/menuPermissionsList", "/category/1/5", "/address/all", "/goods/1/5", '/albumCollection/club/homepage/save', "/storeMember/tag/checked/1/10", "/storeMember/tag/1/10", "/upload/signatureUrl", "/tag/scenario/1/100", "/menu/all", "/tagGroup/scenario"]

// 请求拦截器
instance.interceptors.request.use(config => {
        const token = userTokenStore().token
        // 俱乐部页面登录单独处理headers
        console.log("config.url", config.url);
        if (config.url === "/login/club" || config.url === "/merchant/login") {
            console.log("run in config.url")
            config.headers['Login-Type'] = "8";
        }
        // 登录后添加 token 等请求头信息
        if (token) {
            config.headers['Authorization'] = token.tokenValue;
            config.headers['Login-Type'] = token.loginType;
        }
        /*配置节流*/
        // 设置节流过期时间、节流地址
        const currentTime = Date.now();
        const ttlTime = localStorage.getItem('ttlTime');
        const url = localStorage.getItem('url')
        // 如果本地存储有 ttlTime和url，进行节流判断
        if (ttlTime && currentTime - parseInt(ttlTime, 10) < 1000 && url === config.url && !whiteList.some(white => white === url)) {
            return Promise.reject({message: '请求过于频繁，请稍后再试'});
        }
        // 更新本地存储中的请求时间
        localStorage.setItem('ttlTime', currentTime.toString());
        // 更新本地储存中的请求地址
        localStorage.setItem('url', config.url);

        return config;
    },
    error => {
        // 请求错误处理
        ElMessage({
            message: error,
            type: 'error'
        })
        return Promise.reject(error);
    }
);

// 响应拦截器
instance.interceptors.response.use(
    response => {
        if (response.data.code !== 1) {
            if (response.data.show) {
                // 弹窗展示错误信息
                //操作失败
                //异步操作的状态转换为失败
                ElMessage({
                    message: response.data.msg,
                    type: 'error'
                })
                console.log("response:", response);
                return Promise.reject(response.data.msg)
            }
            return Promise.reject('服务异常')
        } else {
            // 响应数据处理
            return response.data.data;
        }
    },
    error => {
        let errMsg = error.message
        console.log("err:", error)
        console.log("error.status:", error.status)
        if (error.code === 'ERR_NETWORK') {
            errMsg = '网络异常，请稍后重试'
        } else if (error.code === 'ECONNABORTED') {
            errMsg = '请求超时，请稍后重试'
        } else if (error.status >= 400) {
            errMsg = error.response.data.show ? error.response.data.msg : "未知错误"
            console.log("接口请求错误，原因：", error.response.data.msg)
        }
        // show的时候才展示
        if (error.response.data.show) {
            // 错误响应处理
            ElMessage({
                message: errMsg,
                type: 'error'
            })
        }
        // 401为登录过期，登出
        if (error.status === 401) {
            userLogoutHooks(false)
        }
        return Promise.reject(errMsg);
    }
);

export default instance;
